import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { vitecompanyserviceurl } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";

const companyserviceurl: AxiosInstance = axios.create({
  baseURL: vitecompanyserviceurl + "/api/v1/oms",
});

const companyserviceurlevent: AxiosInstance = axios.create({
  baseURL: vitecompanyserviceurl,
});

companyserviceurl.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
companyserviceurlevent.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));

export const getStockistBlockList = (
  is_blocked?: boolean | undefined,
  pageIndex?: number,
  perPage?: number,
  filtersQuery?: string,
  search?: string

) => {
  const queryParams = new URLSearchParams();

  if (is_blocked !== undefined) queryParams.append("is_blocked", String(is_blocked));
  if (pageIndex !== undefined) queryParams.append("page", pageIndex.toString());
  if (perPage !== undefined) queryParams.append("perPage", perPage.toString());
  if (search !== undefined) queryParams.append("search", search.toString());

  let url = `/stockist_block?${queryParams.toString()}`;

  if (filtersQuery) {
    url += `&${filtersQuery}`;
  }

  return companyserviceurl.get(url);
};

export const updateStockistBlockRevoke = (payload: any, company_code: number) => {
  return companyserviceurlevent.post(
    `/event/stockist_block/add`,
    payload,
    {
      headers: {
        company_code: company_code || 0,
      },
      validateStatus: (status) => status < 500 && status >= 200,
    }
  );
};




